export const environment = {
  production: false,
  environmentName: 'Test',
  hubServerUrl: 'https://iris-test-hub-internal.curtin.edu.au',
  clientServerProtocol: 'https',
  clientServerDomain: 'curtin.edu.au',
}
